import { Link } from "gatsby"
import React, { FC } from "react"

interface Props {
  currentPage: number
  numPages: number
  prefix: string
}
const Pagination: FC<Props> = ({ currentPage, numPages, prefix }) => {
  const isFirst = currentPage === 1
  const isLast = currentPage === numPages

  const prevPage =
    currentPage - 1 === 1 ? prefix : `${prefix}${(currentPage - 1).toString()}`
  const nextPage = `${prefix}${(currentPage + 1).toString()}`
  return (
    <div className="flex justify-center w-full">
      <Link
        className={`mr-3 text-lg text-gray-700 hover:text-orange-500 transition-all ${
          !isFirst ? "block" : "hidden"
        }`}
        to={prevPage}
        rel="prev"
      >
        ← Previous
      </Link>

      {Array.from({ length: numPages }, (_, index) => (
        <Link
          className={`mx-3 sm:px-3 text-lg hover:text-orange-500 transition-all ${
            currentPage === index + 1 ? "text-orange-500" : "text-gray-700"
          }`}
          key={`pagindexnatindexon-number${index + 1}`}
          to={`${prefix + (index === 0 ? "" : index + 1)}`}
        >
          {index + 1}
        </Link>
      ))}

      <Link
        className={`ml-3 text-lg text-gray-700 hover:text-orange-500 transition-all ${
          !isLast ? "block" : "hidden"
        }`}
        to={nextPage}
        rel="next"
      >
        Next →
      </Link>
    </div>
  )
}

export default Pagination
